//
//
//
//
//
//
//
//
//

import  List  from "./list.vue";
import { statisticsConfig } from '@/utils/statisticsConfig'
import { customer } from '@/utils/customer/index.js'

export default {
    data() {
        return {
            type: null,
            list:[]
        }
    },
    props: {
        message: {
            type: [String,Array],
            default: '内容'
        },
        phoneStatic:{  // 电话埋点
            type: [String],
            default: ''
        },
        listStatic:{  // 列表埋点
            type: [String],
            default: ''
        }
    },
    components: {
        List,
    },
    watch:{
        message:{
            deep:true,
            handler(newValue,oldValue){
                 // 列表是否为问答 是则展示 折叠列表
                if(this.message && this.message[0]){
                    this.message[0].hasOwnProperty('question')? this.type = 2 : this.type = 1 ;
                }
                this.reset()
            }
        }
    },
    created(){
        // 列表是否为问答 是则展示 折叠列表
        if(this.message && this.message[0]){
            this.message[0].hasOwnProperty('question')? this.type = 2 : this.type = 1 ;
        }
        this.reset()
    },
    methods: {
        // 格式化数据
        reset() {
            this.list = [];
            if(this.message && typeof this.message == 'object' && this.message.length){
                this.message.forEach(element => {
                    element.setTitle = element.question || element.content
                    element.setContent = element.answer || element.description
                    this.list.push(element)
                });
            }
            
        },
        // 折叠列表点击展开的埋点
        showItemClick(){
            if(this.listStatic && this.type == 2){
                statisticsConfig[this.listStatic]()
            }

        },
        // 给富文本内的电话号码加 埋点
        phoneClick(e){
            if(e.target.getAttribute("class") && e.target.getAttribute("class").indexOf('editor_phoneNumber') != -1){
                // 添加埋点
                if(this.phoneStatic){
                   statisticsConfig[this.phoneStatic]()
                }
                var num= (e.target.innerHTML).replace(/[^0-9]/ig,"");
                // 拨打电话
                if(num){
                    customer.customerLink(null,num)
                }
                
            }
        }
    },
}
